import React, { useState, useEffect } from 'react';
import '../index.css';
import './editTable2.css'; // Deine CSS-Datei
import {
  searchRecordInAirTable,
  updateRecordInAirTable,
  createRecordInAirTable
} from '../functions.js/airTableDB';

const RolesPage = () => {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [newRole, setNewRole] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedRoles = await searchRecordInAirTable('roles');
      setRoles(fetchedRoles || []);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <p>Lade Daten...</p>;
  }

  return (
    <div className="roles-container modernContainer">
      <h2>Rollen</h2>
      <RolesTable
        roles={roles}
        setRoles={setRoles}
        newRole={newRole}
        setNewRole={setNewRole}
      />
    </div>
  );
};

const RolesTable = ({ roles, setRoles, newRole, setNewRole }) => {
  // Zustand für die Bearbeitung der Rollen
  const [editedRoles, setEditedRoles] = useState({});
  const [originalRoles, setOriginalRoles] = useState({});

  // Initialisiert den Zustand beim ersten Laden / sobald "roles" sich ändert
  useEffect(() => {
    const edits = {};
    const originals = {};

    roles.forEach(role => {
      edits[role.id] = {
        name: role.fields?.name || ''
      };
      originals[role.id] = { ...edits[role.id] };
    });

    setEditedRoles(edits);
    setOriginalRoles(originals);
  }, [roles]);

  // Lokales Eingabe-Event
  const handleInputChange = (roleId, newName) => {
    setEditedRoles(prev => ({
      ...prev,
      [roleId]: {
        name: newName
      }
    }));
  };

  // Prüft, ob sich Änderungen gegenüber dem Original ergeben haben
  const hasChanges = (roleId) => {
    const original = originalRoles[roleId] || {};
    const current = editedRoles[roleId] || {};
    return original.name !== current.name;
  };

  // Validierung der Rolle (nur 'name' muss gefüllt sein)
  const validateRole = (roleData) => {
    return roleData.name.trim() !== '';
  };

  // Speichert eine bestehende Rolle
  const handleSave = async (roleId) => {
    if (!hasChanges(roleId)) return;

    const current = editedRoles[roleId];
    if (!validateRole(current)) {
      alert('Bitte den Namen der Rolle ausfüllen.');
      return;
    }

    const updatedData = {
      name: current.name
    };

    // Update in Airtable
    await updateRecordInAirTable(roleId, updatedData, 'roles');

    // Aktualisiere den lokalen State
    setRoles(prev =>
      prev.map(role =>
        role.id === roleId
          ? { ...role, fields: { ...role.fields, ...updatedData } }
          : role
      )
    );
    // Originalwerte anpassen
    setOriginalRoles(prev => ({
      ...prev,
      [roleId]: { ...current }
    }));
  };

  // Änderungen an einer Rolle verwerfen
  const handleDiscard = (roleId) => {
    setEditedRoles(prev => ({
      ...prev,
      [roleId]: { ...originalRoles[roleId] }
    }));
  };

  // Speichern einer neuen Rolle
  const handleNewSave = async () => {
    if (!newRole || !validateRole(newRole)) {
      alert('Bitte den Namen der Rolle ausfüllen.');
      return;
    }

    const newData = {
      name: newRole.name
    };

    const result = await createRecordInAirTable(newData, 'roles');
    if (result) {
      setRoles(prev => [...prev, result]);
      setNewRole(null);
    }
  };

  // Abbrechen beim Erstellen einer neuen Rolle
  const handleNewCancel = () => {
    setNewRole(null);
  };

  return (
    <>
      <table className="modern-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {/* Bestehende Rollen */}
          {roles.map(role => (
            <tr key={role.id}>
              <td>
                <input
                  type="text"
                  value={editedRoles[role.id]?.name || ''}
                  onChange={(e) => handleInputChange(role.id, e.target.value)}
                />
              </td>
              <td className="actions-td">
                {hasChanges(role.id) && (
                  <>
                    <button
                      className="btn save"
                      onClick={() => handleSave(role.id)}
                    >
                      💾
                    </button>
                    <button
                      className="btn discard"
                      onClick={() => handleDiscard(role.id)}
                    >
                      ✖
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}

          {/* Neue Rolle erstellen */}
          {newRole && (
            <tr className="new-row">
              <td>
                <input
                  type="text"
                  placeholder="Rollenname"
                  value={newRole.name}
                  onChange={(e) =>
                    setNewRole({ ...newRole, name: e.target.value })
                  }
                />
              </td>
              <td className="actions-td">
                <button className="btn save" onClick={handleNewSave}>
                  💾
                </button>
                <button className="btn discard" onClick={handleNewCancel}>
                  ✖
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Button zum Anlegen einer neuen Rolle */}
      {!newRole && (
        <button
          className="btn new-group"
          onClick={() => setNewRole({ name: '' })}
        >
          + Neue Rolle
        </button>
      )}
    </>
  );
};

export default RolesPage;